module.exports = "/_next/static/images/ourPartnersLogo1-a5e729c0fd0eea9255cad9d9929954bc.webp";